import * as angular from 'angular';

(function () {
    'use strict';

    angular
        .module('app')
        .controller('SettlementFilterController', SettlementFilterController);

    function SettlementFilterController($scope, IMieszkaniecFactory) {
        var vm = this;

        init();

        function init() {
            getSettlements();
        }

        function getSettlements() {
            $scope.$watch(
                function () {
                    return vm.client;
                },
                function () {
                    if (vm.client && vm.client.som_url) {
                        IMieszkaniecFactory.fetchSettlements(
                            vm.client.som_url,
                            {}
                        ).then(function (response) {
                            vm.settlements = response.data.results;
                        });
                    } else {
                        vm.settlement = undefined;
                        vm.settlements = [];
                    }
                },
                true
            );
        }
    }
})();



// WEBPACK FOOTER //
// ./node_modules/angularjs-template-loader??ref--0-1!./src/app/components/issues/filters/settlement-filter/settlement-filter.controller.ts